import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import qualityPlaceholder from "../../assets/quality-config-placeholder.svg";
import standardPlaceholder from "../../assets/standard-config-placeholder.svg";
import quantityPlaceholder from "../../assets/quantity-config-placeholder.svg";
import { Box, Tooltip, makeStyles } from "@material-ui/core";
import { useUserContext } from "../../providers/userProvider";
const useStyles = makeStyles(() => ({
  tooltip: { zIndex: 10000 },
}));

const ConfigOption = ({ typeInfo, image, handleSubmit }) => {
  let tempImage =
    image !== undefined
      ? image
      : typeInfo.title === "Quantity"
      ? quantityPlaceholder
      : typeInfo.title === "Quality"
      ? qualityPlaceholder
      : standardPlaceholder;

  let staticImage = (
    <img
      style={{ height: "auto", width: "100%", maxWidth: "200px", display: "block", margin: "0 auto" }}
      src={tempImage}
      alt={`${typeInfo.title} Product`}
    ></img>
  );

  const classes = useStyles();
  const user = useUserContext();
  return (
    <Box pt={2}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 20,
        }}
      >
        <h2>Price Volume Decision</h2>
        {user.role === "student" ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            type="submit"
          >
            Select {typeInfo.title}
          </Button>
        ) : (
          <Tooltip
            title="Only students are allowed to select a configuration."
            placement="top"
            classes={{ popper: classes.tooltip }}
            arrow
          >
            <span>
              {" "}
              {/* https://material-ui.com/components/tooltips/#disabled-elements */}
              <Button variant="contained" color="primary" disabled>
                Select {typeInfo.title}
              </Button>
            </span>
          </Tooltip>
        )}
      </div>
      <p style={{ marginTop: 20 }}>
        The first decision your company will need to make in the simulated
        marketplace is the pricing strategy of your product. 
      </p>
      <p style={{ marginTop: 20 }}>
        Regardless of what product your team ultimately dreams up, you will need
        to decide on how much it should cost. WILE allows all companies to
        choose between three strategies – <b>Quantity</b>, <b>Standard</b>, and
        <b>Quality</b>. To help teams decide which pricing strategy to choose,
        WILE uses a smartphone as a reference. 
      </p>
      <p style={{ marginTop: 20 }}>
        Smartphones are a great example of a product with a variety of pricing
        strategies. For example, phones with a <u>quality pricing strategy</u>,
        such as Apple iPhones, Google Pixels, and Samsung Galaxies are expensive
        and offer premium features. On the opposite end, smartphones with a
        <u>quantity pricing strategy</u>, such as a feature phone, have the same
        basic features as a quality phone, but often lack performance and
        overall customer appeal.
      </p>
      <Grid container spacing={3}>
        <div className="root-flex" style={{ paddingTop: 20 }}>
          <Grid item xs={12}>
            <div className="block" style={{ padding: 10, margin: 10 }}>
              <div>
                <h2>{typeInfo.title}</h2>
              </div>
              <div style={{ textAlign: "center" }}>{staticImage}</div>
              <div>
                <h2>Overview</h2>
                <p>{typeInfo.overview}</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="block" style={{ padding: 10, margin: 10 }}>
              <h2>Pros</h2>
              <ul style={{ marginLeft: 20 }}>
                {typeInfo.pros.map((opt, index) => (
                  <li key={index}>{opt}</li>
                ))}
              </ul>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="block" style={{ padding: 10, margin: 10 }}>
              <h2>Cons</h2>
              <ul style={{ marginLeft: 20 }}>
                {typeInfo.cons.map((opt, index) => (
                  <li key={index}>{opt}</li>
                ))}
              </ul>
            </div>
          </Grid>
        </div>
      </Grid>
    </Box>
  );
};

ConfigOption.propTypes = {
  typeInfo: PropTypes.object.isRequired,
  image: PropTypes.any.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default ConfigOption;
